import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { View } from 'foundations-components/transitional/components/View';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function DetailsPage({
  leftColumn,
  rightColumn
}) {
  const {
    published
  } = useDetailsPageContext();
  const isPreview = !published;
  const previewBanner = /*#__PURE__*/_jsx(Alert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "detailsPage.previewAlert.titleText"
    }),
    type: "warning",
    marginBlockEnd: "500",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "detailsPage.previewAlert.message"
    })
  });
  return /*#__PURE__*/_jsxs(View, {
    backgroundColor: "fill-surface-recessed",
    "data-test-id": "details-page",
    children: [isPreview && previewBanner, /*#__PURE__*/_jsxs(Grid, {
      columnGap: "0",
      paddingInline: "0",
      children: [/*#__PURE__*/_jsx(GridItem, {
        paddingInlineEnd: "300",
        size: {
          xs: 12,
          md: 4
        },
        marginBlockEnd: "500",
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            position: 'sticky',
            top: '24px'
          },
          children: [leftColumn, " "]
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        paddingInlineStart: "300",
        size: {
          xs: 12,
          md: 8
        },
        children: rightColumn
      })]
    })]
  });
}